import React from "react";
import "./bottomUpSheet.css";

const BottomUpSheet = ({
  isOpen,
  onClose,
  mealsDetails,
  onTncClick,
  onCancelClick,
  isCancelled
}) => {
  return (
    <>
      {isOpen && <div className="overlay" onClick={onClose}></div>}

      <div className={`sheet ${isOpen ? "slideUp" : "slideDown"}`}>
        <div className="foodHeader">
          <div>
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/FOB/foodIcon.svg"
              alt="food-icon"
            />
            <p className="title">Food Details</p>
          </div>
          <img
            src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/FOB/close.svg"
            alt="close-icon"
            className="closeIcon"
            onClick={onClose}
          />
        </div>

        <div className="tncSection">
          <span className="subText">Check ‘View T&C’ for details</span>
          <span className="tnc" onClick={onTncClick}>
            View T&Cs
          </span>
        </div>

        {isCancelled ? (
          <div className="cancelledWrapper">
            <p>Food Order Cancelled</p>
            {mealsDetails.priceDetails.refundAmount > 0 ? (
              <span>
                Refund of ₹{mealsDetails.priceDetails.refundAmount} has been
                initiated to your original payment method. It should reflect
                within 5-7 business days.{" "}
              </span>
            ) : null}

            <div className="foodList">
              {mealsDetails.orderedFoodItemsDetails.map((meal, idx) => (
                <div key={idx} className="foodCard">
                  <div className="left">
                    <div>
                      <div>
                        <img
                          className="vegIcon"
                          src={
                            meal.veg
                              ? "https://d1flzashw70bti.cloudfront.net/next-gen/images/selfHelp/vegSymbol.webp"
                              : "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/nonveg.svg"
                          }
                          alt="veg"
                        />
                        <span>{meal.veg ? "Veg" : "Non Veg"}</span>
                      </div>
                      <p className="mealName">
                        {meal.displayName}{" "}
                        {meal.quantity && meal.quantity > 1
                          ? "x" + meal.quantity
                          : null}
                      </p>
                      <p className="price">
                        {meal.totalPaid === 0 ? "Free" : `₹${meal.totalPaid}`}
                        {meal.totalCost <= meal.totalPaid ? null : (
                          <span className="cutPrice">₹{meal.totalCost}</span>
                        )}
                      </p>
                    </div>
                  </div>

                  <img
                    src={
                      "https://d1flzashw70bti.cloudfront.net/" + meal.webImage
                    }
                    alt={meal.displayName}
                    className="cancelledMealImage"
                  />
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="foodList">
            {mealsDetails.orderedFoodItemsDetails.map((meal, idx) => (
              <div key={idx} className="foodCard">
                <div className="left">
                  <div>
                    <div>
                      <img
                        className="vegIcon"
                        src={
                          meal.veg
                            ? "https://d1flzashw70bti.cloudfront.net/next-gen/images/selfHelp/vegSymbol.webp"
                            : "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/nonveg.svg"
                        }
                        alt="veg"
                      />
                      <span>{meal.veg ? "Veg" : "Non Veg"}</span>
                    </div>
                    <p className="mealName">
                      {meal.displayName}{" "}
                      {meal.quantity && meal.quantity > 1
                        ? "x" + meal.quantity
                        : null}
                    </p>
                    <p className="price">
                      {meal.totalPaid === 0 ? "Free" : `₹${meal.totalPaid}`}
                      {meal.totalCost <= meal.totalPaid ? null : (
                        <span className="cutPrice">₹{meal.totalCost}</span>
                      )}
                    </p>
                  </div>
                </div>

                <img
                  src={"https://d1flzashw70bti.cloudfront.net/" + meal.webImage}
                  alt={meal.displayName}
                  className="mealImage"
                />
              </div>
            ))}
            {mealsDetails.canCancelFood ? (
              <button className="cancelFoodBtn" onClick={onCancelClick}>
                Cancel Order
              </button>
            ) : null}
          </div>
        )}
      </div>
    </>
  );
};

export default BottomUpSheet;
